import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

const Services = () => {
    const { language } = useLanguage();
    const [loading, setLoading] = useState(true);

    const desktopImage = language === 'fa' ? '/d-1.svg' : '/d-1-eng.svg';
    const mobileImage = language === 'fa' ? '/d-m.png' : '/d-m-eng.png';

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => {
            setLoading(false);
        }, 300);
        return () => clearTimeout(timer);
    }, [language]);

    if (loading) {
        return (
            <div className="w-full mt-6 sm:mt-8 px-3 sm:px-4">
                <div className="w-full max-w-4xl h-[100px] sm:h-[150px] md:h-[200px] bg-gray-100 animate-pulse rounded-xl mx-auto" />
            </div>
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="w-full mt-6 sm:mt-8 px-3 sm:px-4"
            id="services"
        >
            <img src={desktopImage} className="w-auto hidden md:block mx-auto" alt="Dekorasyon" />
            <img src={mobileImage} className="mx-auto w-full max-w-md block md:hidden" alt="Dekorasyon Mobil" />
        </motion.div>
    );
};

export default Services;